import { Component, Inject, OnDestroy } from '@angular/core';

import { Store } from '@src/store';
import { ActivityDataSource } from './activity.data-source';

@Component({
    selector: 'environment-activities',
    template: require('./environment-activities.component.html'),
    styles: [require('./environment-activities.component.scss')]
})
export class EnvironmentActivitiesComponent implements OnDestroy {
    public activities: ActivityDataSource;

    constructor(
        @Inject('$filter') private $filter: any,
        private store: Store,
        @Inject('$stateParams') $stateParams: any) {
        const projectId = $stateParams.id;
        const periodId = 7; // Timeless
        const envID = $stateParams.envID;
        this.activities = new ActivityDataSource(this.store, this.$filter, projectId, periodId, envID);
    }

    public ngOnDestroy() {
        this.activities.disconnect();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/environmentDetails/environment-activities/environment-activities.component.ts